import React from "react";
import Select from 'react-select';

interface Option {
    value: string | number,
    label: string
}

interface BrandSelectionProps {
    value: Option | null,
    onChange: (brand: Option | null) => void
    [key: string]: unknown
}

const BrandSelection: React.FC<BrandSelectionProps> = ({ value, onChange, ...rest }) => {
    const customStyles = {
        option: (provided: Record<string, unknown>, state: { isSelected: boolean, isFocused: boolean }) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#0069AD' : state.isFocused ? '#BBD8ED' : 'white',
            color: state.isSelected ? 'white' : 'black',
        }),
    };

    return (
        <Select
            {...rest}
            isDisabled
            styles={customStyles}
            options={value ? [value] : []}
            classNamePrefix="brand-select"
            placeholder="Brand"
            value={value}
            onChange={onChange}
        />
    );
};

export default BrandSelection;
